export const c_menu_m_flyout__menu_top_offset = {
  "name": "--pf-v5-c-menu--m-flyout__menu--top-offset",
  "value": "0px",
  "var": "var(--pf-v5-c-menu--m-flyout__menu--top-offset)"
};
export default c_menu_m_flyout__menu_top_offset;